<template>
  <v-container fluid>
    <h1 class="headline">{{ $t('pages.statistics.title') }}</h1>
    <DateIntervalPicker
      v-model="interval"
      class="mb-3">
    </DateIntervalPicker>
    <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
    <v-layout row wrap v-else>
      <v-flex 
        v-for="stat in stats" :key="stat.key"
        xs12 sm4 class="mb-3">
        <stat :title="$t(`pages.statistics.${stat.key}`)">
          <component v-if="stat.component" :is="stat.component" :value="stat.value"/>
          <span v-else>{{ stat.value }}</span>
        </stat>
      </v-flex>
    </v-layout>
    <v-card v-if="$can('viewStats', 'team')">
      <v-data-table
        :headers="headers"
        :items="filteredData"
        :custom-sort="a => a"
        hide-actions>
        <template slot="items" scope="props">
          <td>
            <router-link 
              :to="{ name: 'Expert', params: { id: props.item.expert.id, tab: 'profile' } }">
              {{ props.item.expert.nickname }}
            </router-link>
          </td>
          <td class="text-xs-right"><minute :value="props.item.call_duration.total"/></td>
          <td class="text-xs-right">{{ props.item.call_duration.count }}</td>
          <td class="text-xs-right"><minute :value="props.item.call_duration.avg"/></td>
          <td class="text-xs-right"><price :value="props.item.gains.sum"/></td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Metrics from '@/api/metrics'
  import { Minute, Price } from '@/components/formatters'
  import Stat from '@/components/Stat.vue'
  import withInterval from '@/mixins/withInterval'
  export default {
    components: {
      Stat,
      Minute,
      Price
    },
    mixins: [withInterval],
    data () {
      return {
        data: {
          experts: [],
          price: {}
        },
        loading: false
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'skiliko/session/currentUser'
      }),
      headers () {
        return [
          { text: this.$t('pages.statistics.expert'), left: true, sortable: false },
          { text: this.$t('pages.statistics.sum'), left: false, sortable: false },
          { text: this.$t('pages.statistics.total'), left: false, sortable: false },
          { text: this.$t('pages.statistics.average'), left: false, sortable: false },
          { text: this.$t('pages.statistics.gains'), left: false, sortable: false }
        ]
      },
      filteredData () {
        return this.$can('viewStats', 'team')
          ? [...this.data.experts]
          : this.data.experts.filter(x => x.expert.id === this.currentUser.id)
      },
      sum () {
        return this.filteredData
          .map(x => x.call_duration.total)
          .reduce((res, x) => res + x, 0)
      },
      total () {
        return this.filteredData
          .map(x => x.call_duration.count)
          .reduce((res, x) => res + x, 0)
      },
      average () {
        return this.filteredData
          .map(x => x.call_duration.avg)
          .reduce((res, x) => res + x, 0) / this.filteredData.length
      },
      stats () {
        const collectorValue = this.data.collector ? [
          ...this.data.collector.availables,
          ...this.data.collector.pendings
        ].reduce((prev, x) => prev + x.amount, 0) : 0
        return [
          { key: 'sum', component: Minute, value: this.sum },
          { key: 'total', value: this.total },
          { key: 'average', component: Minute, value: this.average },
          this.data.price && this.data.price.minute ? { key: 'price_minute', component: Price, value: this.data.price.minute } : null,
          this.data.price && this.data.price.average ? { key: 'price_average', component: Price, value: this.data.price.average } : null,
          this.data.collector ? { key: 'collector', component: Price, value: collectorValue } : null
        ].filter(x => x)
      }
    },
    methods: {
      async reloadStats () {
        this.loading = true
        this.data = (await Metrics.expertStats({ params: this.params })).data
        this.loading = false
      }
    },
    watch: {
      params () {
        this.reloadStats()
      }
    },
    mounted () {
      this.reloadStats()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Statistics.vue